import React, { useState, useEffect } from "react"
import Hamburger from "hamburger-react"
import { Link } from "gatsby"
import {
  BsSun,
  BsMoonStars,
  BsHouse,
  BsPerson,
  BsBriefcase,
  BsImage,
  BsPencilSquare,
  BsTelephone,
} from "react-icons/bs"

const Navbar = ({ logo }) => {
  const darkTheme = "dark-theme"

  const [themeIcon, SetThemeIcon] = useState("light")

  const [isOpen, setOpen] = useState(false)

  useEffect(() => {
    const nav_Menu = document.getElementById("nav-menu")
    function scrollHeader() {
      const nav = document.getElementById("header")

      if (window.scrollY >= 80) {
        nav.classList.add("scroll-header")
        nav_Menu.classList.remove("show-menu")
        setOpen(false)
      } else {
        nav.classList.remove("scroll-header")
      }
    }

    document.querySelector(".nav__logo").addEventListener("click", () => {
      document
        .querySelector(":root")
        .style.setProperty("--scroll-behavior", "auto")
    })

    if (isOpen) {
      nav_Menu.classList.add("show-menu")
    } else {
      nav_Menu.classList.remove("show-menu")
    }

    window.addEventListener("scroll", scrollHeader)

    /*==================== DARK LIGHT THEME ====================*/

    const themeButton = document.getElementById("theme-button")

    // Previously selected topic (if user selected)

    const selectedTheme = localStorage.getItem("selected-theme")

    // We obtain the current theme that the interface has by validating the dark-theme class

    const getCurrentTheme = () => {
      return document.body.classList.contains(darkTheme) ? "dark" : "light"
    }
    // We validate if the user previously choose a topic

    if (selectedTheme) {
      // If the validation is fulfilled, we ask what the issue was to know if we activated or deactivated the dark
      document.body.classList[selectedTheme === "dark" ? "add" : "remove"](
        darkTheme
      )

      if (selectedTheme === "light" || selectedTheme === null) {
        // If the validation is fulfilled, we ask what the issue was to know if we activated or deactivated the dark
        SetThemeIcon("light")
      } else {
        SetThemeIcon("dark")
      }
    }

    // Activate / deactivate the theme manually with the button

    themeButton.addEventListener("click", event => {
      // Add or remove the dark / icon theme
      event.preventDefault()
      document.body.classList.toggle(darkTheme)
      // We save the theme and the current icon that the user chose
      localStorage.setItem("selected-theme", getCurrentTheme())

      if (localStorage.getItem("selected-theme") === "dark") {
        SetThemeIcon("dark")
      } else if (localStorage.getItem("selected-theme") === "light") {
        SetThemeIcon("light")
      }
    })
  }, [themeIcon, isOpen])

  return (
    <header className="header noSelect" id="header">
      <nav className="nav container">
        <Link className="nav__logo" to="/">
          <span className="angleBracket ab1">{"<"}</span>
          {logo}
          <span className="angleBracket ab2">{"/"}</span>
          <span className="angleBracket ab3">{">"}</span>
        </Link>

        <div className="nav__menu" id="nav-menu">
          <ul className="nav__list grid">
            <>
              <li>
                <Link
                  className="nav__link page_links"
                  to={"/"}
                  activeClassName="nav__link__active"
                >
                  <BsHouse className="nav__icon" /> Home
                </Link>
              </li>
              <li>
                <Link
                  className="nav__link page_links"
                  to={"/about"}
                  activeClassName="nav__link__active"
                >
                  <BsPerson className="nav__icon" /> about
                </Link>
              </li>
              <li>
                <Link
                  className="nav__link page_links"
                  to={"/services"}
                  activeClassName="nav__link__active"
                >
                  <BsBriefcase className="nav__icon" /> services
                </Link>
              </li>
              <li>
                <Link
                  className="nav__link page_links"
                  to={"/portfolio"}
                  activeClassName="nav__link__active"
                >
                  <BsImage className="nav__icon" /> portfolio
                </Link>
              </li>
              <li>
                <Link
                  className="nav__link page_links"
                  to={"/blog"}
                  activeClassName="nav__link__active"
                >
                  <BsPencilSquare className="nav__icon" /> blog
                </Link>
              </li>
              <li>
                <Link
                  className="nav__link page_links"
                  to={"/contact"}
                  activeClassName="nav__link__active"
                >
                  <BsTelephone className="nav__icon" /> contact
                </Link>
              </li>
            </>
          </ul>
        </div>

        <div className="nav__btns">
          {/* Theme change button */}

          {themeIcon === "dark" ? (
            <BsMoonStars className="change-theme " id="theme-button" />
          ) : (
            <BsSun className="change-theme " id="theme-button" />
          )}

          <div className="nav__toggle" id="nav-toggle">
            <Hamburger
              toggled={isOpen}
              toggle={setOpen}
              rounded
              direction="right"
              hideOutline={false}
              duration={0.6}
              size={18}
            />
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Navbar
